/**
 * Minimal JS waterfall/masonry.
 * Largely based on TinyMasonry (https://github.com/aishikaty/tiny-masonry).
 *
 * Markup example:
 * ```
 * <div id="en-waterfall" class="en-grid">
 *     <div class="en-griditem" data-en-griditem-small="2-1" data-en-griditem-medium="3-1"></div>
 *     <div class="en-griditem" data-en-griditem-small="2-1" data-en-griditem-medium="3-1"></div>
 *     <div class="en-griditem" data-en-griditem-small="2-1" data-en-griditem-medium="3-1"></div>
 *     ...
 * </div>
 * ```
 *
 * Implementation example:
 * ```
 * var myWaterfall = new EN.Waterfall($('#en-waterfall'));
 * ```
 *
 * @class Waterfall
 * @author EN GARDE (Martin Holler)
 * @version 1.1.0
 */

var EN = EN || {};

EN.Waterfall = (function ($) {
	'use strict';

	/**
	 * @constructor
	 * @param {jQuery} $element
	 * @param {object} [options]
	 * @property {number} debounce=100
	 * @property {object} classNames
	 */
	function Waterfall($element, options) {
		var that = this;
		var timeout;

		that.options = $.extend({}, that.defaults, options);
		that.$element = $element.first();
		that.$items = $element.children();
		that.$columns = $([]);

		$(window).on('resize', function () {
			clearTimeout(timeout);
			timeout = setTimeout(function () {
				timeout = undefined;
				that.update();
			}, that.options.debounce);
		});

		that.update();
	}

	Waterfall.prototype.defaults = {
		debounce: 100,
		classNames: {
			waterfall: 'en-waterfall en-is-active',
			column: 'en-waterfall__column'
		}
	};

	/**
	 * Creates n columns and appends them to the element.
	 * @memberof Waterfall
	 * @param {number} n
	 * @return {jQuery}
	 */
	Waterfall.prototype.createColumns = function (n) {
		var that = this;
		var width = 100 / n + '%';
		var $column;

		that.$columns = $([]);

		while (n--) {
			$column = $('<div />')
				.addClass(that.options.classNames.column)
				.css({
					width: width,
					float: 'left'
				});

			that.$columns = that.$columns.add($column);
			that.$element.append($column);
		}

		return that.$columns;
	};

	/**
	 * Returns the column with the smallest height.
	 * @memberof Waterfall
	 * @return {jQuery}
	 */
	Waterfall.prototype.getShortestColumn = function () {
		var that = this;
		var $shortest = that.$columns.eq(0);

		that.$columns.each(function () {
			var $column = $(this);

			if ($column.height() < $shortest.height()) {
				$shortest = $column;
			}
		});

		return $shortest;
	};

	/**
	 * Updates the waterfall's layout.
	 * @memberof Waterfall
	 */
	Waterfall.prototype.update = function () {
		var that = this;
		var $measureItem;
		var numberOfColumns;

		// check if items are still valid
		if (that.$columns.length && that.$columns.eq(0).parent().get(0) !== that.$element.get(0)) {
			that.$items = that.$element.children();
		}

		// to measure the required columns, get the first item
		$measureItem = that.$items.eq(0).css('width', '');

		that.$element
			.addClass(that.options.classNames.waterfall)
			.css({
				overflow: 'hidden',
				minHeight: that.$element.height() // this prevents scroll resets when clearing the element
			})
			.empty()
			.append($measureItem);

		numberOfColumns = Math.round(that.$element.width() / ($measureItem.width() || that.$element.width()));

		// clear the element and insert columns
		that.$element.empty();
		that.createColumns(numberOfColumns);

		// put the items into the columns
		that.$items.each(function () {
			that.getShortestColumn().append($(this).css('width', 'auto'));
		});

		that.$element.css('minHeight', '');
	};

	return Waterfall;
}(jQuery));
